@if ($safeNavigationMigration(summary?.content?.text) !== null) {
  <div class="summary">
    <div
      class="text"
      [class.expanded]="expanded"
    >
      {{ summary.content.text }}
    </div>

    <div>
      @if (!expanded) {
        <button
          class="fuchsia small"
          (click)="expanded = true"
        >
          <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"></i> Summary
        </button>
      } @else {
        <button
          class="fuchsia small"
          (click)="expanded = false"
        >
          <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center"></i> Summary
        </button>
      }
    </div>
  </div>
} @else if (!dataSource.deletedAt) {
  @if (isBeforeNow($safeNavigationMigration(summary?.retryAfter))) {
    <moti-button-extended
      [styleClasses]="['small', 'fuchsia']"
      [isLoading]="isGeneratingSummary"
      (click)="generateSummary()"
    >
      <i class="fa-regular fa-sparkles"></i>
      Generate Summary
    </moti-button-extended>
  } @else {
    <moti-progress-bar
      [numerator]="$safeNavigationMigration(summary?.completionPct)"
      [denominator]="100"
      [zeroProgressText]="'Started analysis of ' + $safeNavigationMigration(dataSource.wordCount?.toLocaleString()) + ' words'"
      [showPercentage]="true"
    ></moti-progress-bar>
  }
}
